"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-checklist-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M17.707 22.121l10.707-10.707L27 10l-9.293 9.282L14.414 16 13 17.414z", fillRule: "nonzero" }),
            _react2.default.createElement("path", { d: "M27 17v7.007A3.001 3.001 0 0 1 24.007 27H11.993A3.001 3.001 0 0 1 9 24.007V11.993A3.001 3.001 0 0 1 11.993 9H24v1H11.993A2.001 2.001 0 0 0 10 11.993v12.014C10 25.1 10.897 26 11.993 26h12.014A2.001 2.001 0 0 0 26 24.007V17h1z", fill: "#4C4C4C", fillRule: "nonzero" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-checklist-on.js
// module id = 1836
// module chunks = 0